export default __webpack_public_path__ + "static/media/deleteIcon.091c3a02.svg";